<script lang="ts">
  import { timeSince } from '$utils';
  import Avatar from '../images/Avatar.svelte';
  import RichTextRender from '../posts/RichTextRender.svelte';
  import NotificationTypeSymbol from './NotificationTypeSymbol.svelte';
  import NotificationSeenSetter from './NotificationSeenSetter.svelte';
  import { announcementsModalOpen } from '$stores';
  import MegaphoneIcon from '$icons/MegaphoneIcon.svelte';
  import { goto } from '$app/navigation';
  import type { Notification } from '$shared/lib';
  import { handleNotificationClick } from '$lib/utils/notifications';
  export let notification: Notification;
</script>

<div
  class:bg-mint-dark-1={!notification.isRead}
  class:border-mint-dark-6={!notification.isRead}
  class="border-gray-dark-4 relative flex w-full items-start gap-x-6 rounded border p-6"
>
  <!-- svelte-ignore a11y-missing-content -->
  <button
    on:click={async () => {
      await handleNotificationClick(notification);
      goto('/forums/public');
      announcementsModalOpen.set(true);
    }}
    class="absolute inset-0 z-10 bg-transparent"
  />
  <!-- TODO - new symbol here? -->
  <NotificationTypeSymbol isRead={notification.isRead}
    ><MegaphoneIcon class="text-gray-dark-12" /></NotificationTypeSymbol
  >
  <div class="flex-1 space-y-3 overflow-hidden">
    <h2 class="text-base">Announcement</h2>
    <div class="flex items-center gap-x-2">
      <div class="h-5 w-5">
        <Avatar
          src={notification?.interactingUsers?.[0].avatarUrl}
          seed={notification?.interactingUsers?.[0].username}
        />
        <!-- <span class="text-gray-dark-9 font-inter text-xs">{notification?.interactingUsers?.[0].username}</span> -->
      </div>
      <span class="font-inter text-gray-dark-11 text-sm"
        >{notification?.interactingUsers?.[0].displayName}</span
      >
    </div>

    <div class="max-h-[60px] overflow-hidden shadow-inner">
      {#key notification.contentBody}
        <div class="overflow-hidden whitespace-pre-wrap break-words">
          <RichTextRender content={notification.contentBody ?? ''} />
        </div>
      {/key}
    </div>

    <h3 class="text-gray-dark-11">
      {notification.createdAt && timeSince(new Date(notification.createdAt))}
    </h3>
  </div>
  {#if !notification.isRead}
    <NotificationSeenSetter bind:notificationId={notification.id} />
  {/if}
</div>
